// extracted by mini-css-extract-plugin
export default {"popup":"p1Hom2xtEVrF5nwIV_iw"};